import { render } from "./UpdateTaskCustomField.vue?vue&type=template&id=79fceb6c"
import script from "./UpdateTaskCustomField.vue?vue&type=script&lang=js"
export * from "./UpdateTaskCustomField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__